import { Route } from 'react-router';
import { getSignUpPath } from './SignUpPage/path';
import { SignUpPage } from './SignUpPage/SignUpPage';
import { getSetPasswordPath } from '@/bundle/Auth/AdminOnboardingFlow/SetPasswordPage/path';
import { SetPasswordPage } from '@/bundle/Auth/AdminOnboardingFlow/SetPasswordPage/SetPasswordPage';
import { AuthProtectedRoute } from '@/bundle/Routes/AuthProtectedRoute';
import { AUTH_STEP } from '@/bundle/Auth/const/const';
import { getVerifyOtpCodePath } from './VerifyOtpCodePage/path';
import { VerifyOtpCodePage } from './VerifyOtpCodePage/VerifyOtpCodePage';
import { getAdminCompleteRegistrationPath } from './AdminCompleteRegistrationPage/path/path';
import { AdminCompleteRegistrationPage } from './AdminCompleteRegistrationPage/AdminCompleteRegistrationPage';
import { AdminSetPasswordPage } from './AdminSetPasswordPage/AdminSetPasswordPage';
import { getAdminSetPasswordPath } from './AdminSetPasswordPage/path';

export const ADMIN_ONBOARDING_FLOW_ROUTES = [
  <Route key={getSignUpPath()} path={getSignUpPath()} element={<SignUpPage />} />,
  <Route
    key={getSetPasswordPath()}
    path={getSetPasswordPath()}
    element={
      <AuthProtectedRoute allowedStep={AUTH_STEP.SET_PASSWORD}>
        <SetPasswordPage />
      </AuthProtectedRoute>
    }
  />,
  <Route
    key={getAdminSetPasswordPath()}
    path={getAdminSetPasswordPath()}
    element={
      <AuthProtectedRoute allowedStep={AUTH_STEP.SIGN_UP_SET_PASSWORD}>
        <AdminSetPasswordPage />
      </AuthProtectedRoute>
    }
  />,
  <Route
    key={getVerifyOtpCodePath()}
    path={getVerifyOtpCodePath()}
    element={
      <AuthProtectedRoute allowedStep={AUTH_STEP.EMAIL_OTP}>
        <VerifyOtpCodePage />
      </AuthProtectedRoute>
    }
  />,
  <Route
    key={getAdminCompleteRegistrationPath()}
    path={getAdminCompleteRegistrationPath()}
    element={
      <AuthProtectedRoute allowedStep={AUTH_STEP.SIGN_UP_COMPLETE_REGISTRATION}>
        <AdminCompleteRegistrationPage />
      </AuthProtectedRoute>
    }
  />,
];
